import React from 'react';
import { CheckboxProps } from '@mui/material';
import { CustomIcon } from 'components/CustomIcon';
import palette from 'theme/palette';
import * as Styles from './MBCheckbox.styles';

const iconSizeMultiplier = 13.75;

interface MBCheckboxProps extends Omit<CheckboxProps, 'size' | 'color'> {
  size?: number;
  iconSize?: number;
  checkIconColor?: string;
  checkBackgroundColor?: string;
  backgroundColor?: string;
  variant?: 'square' | 'circle';
  hovered?: boolean;
  hasBorder?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const MBCheckbox: React.FC<MBCheckboxProps> = ({
  size = 22,
  iconSize,
  checkBackgroundColor = palette.primary.main,
  checkIconColor = palette.common.white,
  backgroundColor = 'rgba(0, 0, 0, 0.2)',
  hasBorder = false,
  variant = 'square',
  hovered = false,
  ...rest
}) => (
  <Styles.Checkbox
    checkedIcon={
      <CustomIcon
        name="tick"
        size={iconSize || size / iconSizeMultiplier}
        dense
      />
    }
    disableRipple
    mbSize={size}
    variant={variant}
    backgroundColor={backgroundColor}
    checkIconColor={checkIconColor}
    checkBackgroundColor={checkBackgroundColor}
    hovered={hovered}
    hasBorder={hasBorder}
    {...rest}
  />
);

export default MBCheckbox;
